import type { MenuFamily } from '../types'

const samerpproMenu: MenuFamily = {
        dashboard: {
          main: {
            index: 1,
            arname: 'الادارة',
            enname: 'Management',
            href: '/dashboard',
            to: '/dashboard',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2,3,4,5,7,8,9],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:8,
              main: 1,
              arname: 'تقارير بيانية',
              enname: 'Management',
              href:'/dashboard',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'التعميدات',
              enname: 'Management',
              href:'/dashboard33',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'الاصول الثابتة',
              enname: 'Fixed Assets',
              href:'/management/fixed-assets',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'تقرير اليومية',
              enname: 'Daily Report',
              href:'/reports/income-report',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'تقرير الضريبة',
              enname: 'VAT Report',
              href:'/reports/vat-reports',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'المشتريات',
              enname: 'Purchase',
              href:'/mg-purchase-report',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'تقرير المصروفات',
              enname: 'Expenses Type',
              href:'/reports/expenses-types',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'تقرير الاداء',
              enname: 'KPI Report',
              href:'/reports/kpi-report',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'عروض تسويقية',
              enname: 'Settings',
              href:'/dashboard11',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'العقود',
              enname: 'Settings',
              href:'/dashboard11',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 1,
              arname: 'التحصيل',
              enname: 'Settings',
              href:'/dashboard11',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },


          ]
        },
        customers: {
          main: {
            index: 88,
            arname: 'المبيعات',
            enname: 'Customers',
            href: '/clientList',
            to: '/clientList',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2,3,4,5,7,8,9],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:7,
              main: 88,
              arname: 'اعدادات العروض',
              enname: 'Offers',
              href:'/Offers',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['showOffering']
            },
            {
              index:9,
              main: 88,
              arname: 'مركز الاتصال',
              enname: 'Call Center',
              href:'',
              class:'mytab4',
              groupid:[1,2,3,4,6,7,8],
              // smclass: '', //smclass: 'font-small',
              smclass: '',
              style: '',
              perms: ['showCallCenter']
            },
            {
              index:9,
              main: 88,
              arname: 'التواصل الاجتماعي',
              enname: 'Social Media',
              href:'',
              class:'mytab4',
              groupid:[1,2,3,4,6,7,8],
              // smclass: '', //smclass: 'font-small',
              smclass: '',
              style: '',
              perms: ['showCallCenter']
            },
            {
              index:8,
              main: 88,
              arname: 'العملاء',
              enname: 'Clients',
              href:'/clientList',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:8,
              main: 88,
              arname: 'نقاط المكافآت',
              enname: 'Loyalty Program',
              href:'/loyaltyProgram',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['any']
            },
            {
              index:7,
              main: 88,
              arname: 'عروض السعر',
              enname: 'Quotations',
              href:'/quotations',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['any']
            },
            // {
            //   index:10,
            //   main: 88,
            //   arname: 'تقرير الضمان',
            //   enname: 'Recuring Maint',
            //   href:'/periodic-maint',
            //   // href:'',
            //   style: '',
            //   class:'',
            //   smclass: '', //smclass: 'font-small',
            //   groupid:[1,2,3,4,5,7,8],
            //   perms: ['any']
            // },
            {
              index:10,
              main: 88,
              arname: 'الصيانة الدورية',
              enname: 'Recuring Maint',
              href:'/periodic-maint',
              // href:'',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showPeriodMaint']
            },
            {
              index:10,
              main: 88,
              arname: 'المواعيد',
              enname: 'Booking',
              href:'/calendar',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showBooking']
            },
            {
              index:7,
              main: 88,
              arname: 'العروض التسويقية',
              enname: 'Subscriber',
              href:'/subscriber',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['showSubscriber']
            },


            {
              index:10,
              main: 88,
              arname: 'عقود صيانة',
              enname: 'Maint. Contract',
              href:'/maintContracts',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showMintContract']
            },
            {
              index:10,
              main: 88,
              arname: 'عقود التأمين',
              enname: 'Insurance. Contract',
              href:'/insurance-contracts',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showMintContract']
            },


            {
              index:7,
              main: 88,
              arname: 'تقرير الاعمال',
              enname: 'Work report',
              href:'/reports/workType',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['workreport']
            },


          ]
        },
        workJob: {
          main: {
            index: 99,
            arname: 'المشاريع',
            enname: 'Works',
            href: '/home-project',
            to: '/home-project',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2,3,4,5,7,8,9],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:10,
              main: 99,
              arname: 'المشاريع',
              enname: 'Job Order',
              href:'/home-project',
              class:'',
              // style: 'background:red !important;color:#fff !important;',
              style: '',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,6,7,8],
              perms: ['show_jobcard']
            },

            {
              index:10,
              main: 99,
              arname: 'المواعيد',
              enname: 'Booking',
              href:'/calendar',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showBooking']
            },

          ]
        },
        sales: {
          main: {
            index: 2,
            arname: 'الفواتير',
            enname: 'Sales',
            href: '/invoicelist',
            to: '/invoicelist',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2,3,4,5,6,7,8],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:4,
              main: 2,
              arname: 'فاتورة مبيعات',
              enname: 'Invoices',
              href:'/invoicelist',
              class:'',
              // style: 'background:green !important;color:#fff !important;',
              style: '',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showInvoiceList']
            },
            {
              index:7,
              main: 2,
              arname: 'قائمة المرتجع',
              enname: 'Reurn Invoice',
              href:'/returnList',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,5,6,7,8],
              perms: ['any']
            },
            {
              index:3,
              main: 2,
              arname: 'نقاط البيع',
              enname: 'POS',
              href:'/POS',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['showPOS']
            },
            {
              index:4,
              main: 2,
              arname: 'فاتورة مشتريات',
              style: '',
              enname: 'Purchase',
              href:'/purchase',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:5,
              main:2,
              arname: 'فاتورة مصروفات',
              enname: 'Expenses',
              href:'/general-expenses',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:3,
              main: 2,
              arname: 'التحصيل',
              enname: 'Renewal',
              href:'/invoices-not-paid',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2,3,4,5,7,8],
              perms: ['any']
            },

            {
              index:1,
              main: 2,
              arname: 'تقرير اليومية',
              enname: 'Income Report',
              href:'/reports/income-report',
              class:'mytab4',
              groupid:[1,2],
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main: 2,
              arname: 'تقرير الضريبة',
              enname: 'VAT Report',
              href:'/reports/vat-reports',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
          ]
        },

        accounting: {
          main: {
            index: 3,
            arname: 'المحاسبة',
            enname: 'Accounting',
            href: '/finance/coa',
            to: '/finance/coa',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:1,
              main: 3,
              arname: 'شجرة الحسابات',
              enname: 'Chart Of Account',
              href:'/finance/coa',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main: 3,
              arname: 'القيود',
              enname: 'JVs',
              href:'/finance/jvs',
              class:'mytab4',
              groupid:[1,2,],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:3,
              main: 3,
              arname: 'أرصدة افتتاحية',
              enname: 'Opening Balance',
              href:'/finance/fient',
              class:'mytab4',
              groupid:[1,2,],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:4,
              main: 3,
              arname: 'طرق الدفع',
              enname: 'Payment Types',
              href:'/finance/paytypes',
              class:'mytab4',
              groupid:[1,2,],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:7,
              main: 3,
              arname: 'ربط الدليل',
              enname: 'Integrations',
              href:'/finance/definition',
              class:'mytab4',
              groupid:[1,2,],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:6,
              main: 3,
              arname: 'الأصول الثابتة',
              enname: 'Fixed Assets',
              href:'/finance/fixed-assets',
              class:'mytab4',
              groupid:[1,2,],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:5,
              main: 3,
              arname: 'انواع المصروفات',
              enname: 'Expenses Types',
              href:'/settings/expensesTypes',
              class:'mytab4',
              style: '',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['onlySalesPurchase']
            },
            {
              index:5,
              main:3,
              arname: 'المصروفات',
              enname: 'Expenses',
              href:'/general-expenses',
              style: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },

          ]
        },

        store: {
          main: {
            index: 4,
            arname: 'المخزون',
            enname: 'Inventory',
            href: '/stores',
            to: '/stores',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:4,
              main: 4,
              arname: 'المستودعات',
              style: '',
              enname: 'Stores',
              href:'/stores',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 4,
              arname: 'الوحدات',
              style: '',
              enname: 'Units',
              href:'/inventory/units',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 4,
              arname: 'تحويل مخزون',
              style: '',
              enname: 'Transfer Inevent',
              href:'/stores-transfer',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 4,
              arname: ' الأرصدة الافتتاحية',
              style: '',
              enname: 'Start Inventory',
              href:'/start-Inventory',
              // herf: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:8,
              main: 4,
              arname: 'اقسام المخزون',
              enname: 'Inentory Cats',
              style: '/inventory/products-cats',
              href:'/inventory/products-cats',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:9,
              main: 4,
              arname: 'أصناف المشتريات',
              enname: 'Inentory Items',
              style: '',
              href:'/inventory/products',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 4,
              arname: 'تقرير الجرد',
              style: '',
              enname: 'Inventory Report',
              href:'/inventory-reports',
              // herf: '',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:5,
              main: 4,
              arname: 'الاكثر مبيعا',
              enname: 'Most Sales',
              href:'/report/items-max',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['cars']
            },
            {
              index:5,
              main: 4,
              arname: 'الاقل مبيعا',
              enname: 'Less Sales',
              href:'/report/items-less',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['cars']
            },
          ]
        },
        purchase: {
          main: {
            index: 12,
            arname: 'المشتريات',
            enname: 'Inventory',
            href: '/inventory/vendors',
            to: '/inventory/vendors',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:4,
              main: 12,
              arname: 'الموردين',
              style: '',
              enname: 'Vendors',
              href:'/inventory/vendors',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 12,
              arname: 'أمر شراء',
              style: '',
              enname: 'Purchase',
              href:'/purchase-order',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 12,
              arname: 'المشتريات',
              style: '',
              enname: 'Purchase',
              href:'/purchase',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 12,
              arname: 'مرتجع المشتريات',
              style: '',
              enname: 'purchase Return',
              href:'/purchaseReturn',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },

            {
              index:4,
              main: 12,
              arname: 'تقرير المشتريات',
              style: '',
              enname: 'Purchase Report',
              href:'/purchase-report',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
            {
              index:4,
              main: 12,
              arname: 'طلبات قطع الغيار',
              style: '',
              enname: 'Purchase Requests',
              href:'/purchase-requests',
              class:'',
              smclass: '', //smclass: 'font-small',
              groupid:[1,2],
              perms: ['any']
            },
          ]
        },
        employees: {
          main: {
            index: 5,
            arname: 'الموظفين',
            enname: 'HR',
            href: '/emps/salaries',
            to: '/emps/salaries',
            class: '',
            // smclass: '', //smclass: 'font-small',
            smclass: '',
            groupid: [1,2],
            bgcolor: '#000000',
            color: '#ffffff'
          },
          sub: [
            {
              index:1,
              main: 5,
              arname: 'الموظفين',
              enname: 'Employees',
              href:'/emps/salaries',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main:5,
              arname: 'مسير الرواتب',
              enname: 'Salary Table',
              href:'/emps/salary-table',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: `'font-small',
              smclass: '',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main: 5,
              arname: 'العهد',
              enname: 'Custody',
              href:'/emps/custody',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: `'font-small',
              smclass: '',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main: 5,
              arname: 'الحضور والانصراف',
              enname: 'Attendess',
              href:'/emps/attendees',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: `'font-small',
              smclass: '',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main: 5,
              arname: 'تقرير النسب',
              enname: 'Percentage Report',
              href:'/reports/percent-report',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: `'font-small',
              smclass: '',
              style: '',
              perms: ['any']
            },
            {
              index:2,
              main: 5,
              arname: 'تقرير الاجازات',
              enname: 'Vacation Report',
              href:'/reports/vacation_report',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: `'font-small',
              smclass: '',
              style: '',
              perms: ['any']
            },
            {
              index:5,
              main: 5,
              arname: 'جهاز البصمة',
              enname: 'Supervisor Report',
              href:'',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['cars']
            },

          ]
        },
        reports: {
          main: {
            index: 6,
            arname: 'التقارير',
            enname: 'Reports',
            href: '/reports/income-report',
            to: '/reports/income-report',
            style: '',
            class: '',
            groupid: [1,2],
            bgcolor: '#000000',
            color: '#ffffff',
          },
          sub: [


            {
              index:3,
              main: 6,
              arname: 'كشف حساب',
              enname: 'Statements',
              href:'/reports/statment-report',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:4,
              main: 6,
              arname: 'ميزان المراجعة',
              enname: 'Trial Balance',
              href:'/reports/balance-report',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:5,
              main: 6,
              arname: 'الارباح والخسائر',
              enname: 'PNL Report',
              href:'/reports/bnl-report',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:6,
              main: 6,
              arname: 'الميزانية',
              enname: 'Balance Report',
              href:'/reports/acbalance-report',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:6,
              main: 6,
              arname: 'تقرير الدليل',
              enname: 'COA Report',
              href:'/coa-reports',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:6,
              main: 6,
              arname: 'الدليل بالمجاميع',
              enname: 'COA Totals Report',
              href:'/coa-reports-totals',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:7,
              main: 6,
              arname: 'تقرير المبيعات',
              enname: 'Sales Report',
              href:'/reports/sales-reports',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any1']
            },
            {
              index:7,
              main: 6,
              arname: 'تقرير البائعين',
              enname: 'Salesman Report',
              href:'/reports/salesman-report',
              class:'mytab4',
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },
            {
              index:8,
              main: 6,
              arname: 'تقرير المرتجع',
              enname: 'Return Report',
              href:'/reports/return-reports',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any1']
            },
            {
              index:5,
              main: 6,
              arname: 'تقرير المصروفات',
              enname: 'Expenses Type',
              href:'/reports/expenses-types',
              class:'mytab4',
              groupid:[1,2],
              // smclass: '', //smclass: 'font-small',
              smclass: '', //smclass: 'font-small',
              style: '',
              perms: ['any']
            },

          ]
        },
        settings: {
          main: {
            index: 7,
            arname: 'الاعدادات',
            enname: 'Settings',
            href: '/settings/system-settings',
            to: '/settings/system-settings',
            class: '',
            groupid: [1],
            bgcolor: '#000000',
            color: '#ffffff',
            perms: ['any']
          },
          sub: [
            {
              index:1,
              main: 7,
              arname: 'اعدادات النظام',
              enname: 'System settings',
              href:'/settings/system-settings',
              style: '',
              class:'mytab4',
              groupid:[1,2],
              smclass: '', //smclass: 'font-small',
              perms: ['any']
            },
            {
              index:2,
              main: 7,
              arname: 'المستخدمين',
              enname: 'Users settings',
              href:'/settings/users-settings',
              style: '',
              class:'mytab4',
              smclass: '', //smclass: 'font-small',
              groupid:[1],
              perms: ['any']
            },
            {
              index:3,
              main: 7,
              arname: 'الصلاحيات',
              enname: 'Permissions',
              href:'/settings/permissions-settings',
              style: '',
              class:'mytab4',
              smclass: '', //smclass: 'font-small',
              groupid:[1],
              perms: ['any']
            },
            {
              index:1,
              main: 7,
              arname: 'الربط مع الزكاه',
              enname: 'ZATCA',
              href:'/zatca-phase-2',
              style: '',
              class:'mytab4',
              groupid:[1,2],
              smclass: '', //smclass: 'font-small',
              perms: ['any']
            },
            {
              index:3,
              main: 7,
              arname: 'الربط API',
              enname: 'WhatsApp Settings',
              href:'/settings-whatsapp',
              style: '',
              class:'mytab4',
              smclass: '', //smclass: 'font-small',
              groupid:[1],
              perms: ['any']
            },

            {
              index:6,
              main: 7,
              arname: 'اعدادات الحالات',
              enname: 'Stauts Settings',
              href:'/settings/statuses',
              class:'mytab4',
              smclass: '', //smclass: 'font-small',
              groupid:[1],
              style: '',
              perms: ['any']
            },
            {
              index:6,
              main: 7,
              arname: 'أنواع الاصناف',
              enname: 'Items types',
              href:'/items-types',
              class:'mytab4',
              smclass: '', //smclass: 'font-small',
              groupid:[1],
              style: '',
              perms: ['any']
            },
            {
              index:7,
              main: 7,
              arname: 'اعدادات الطباعة',
              enname: 'Printing Settings',
              href:'/settings/printing',
              class:'mytab4',
              smclass: '', //smclass: 'font-small',
              groupid:[1],
              style: '',
              perms: ['any']
            },
          ]
        },
       zatca: {
          main: {
            index: 1000,
            arname: 'الربط مع الزكاه',
            enname: 'Zatca Phase 2',
            href: '/zatca-phase-2',
            to: '/zatca-phase-2',
            class: '',
            groupid: [0],
            bgcolor: '#1a358fff',
            color: '#ffffff',
            perms: ['any222']
          },
          sub: [

            {
              index:1,
              main: 1000,
              arname: 'الربط مع الزكاه',
              enname: 'ZATCA',
              href:'/zatca-phase-2',
              style: '',
              class:'mytab4',
              groupid:[1,2],
              smclass: '', //smclass: 'font-small',
              perms: ['any']
            },

          ]
        },
        logout: {
          main: {
            index: 101,
            arname: 'تسجيل خروج',
            enname: 'Logout',
            href: '/logout',
            to: '/logout',
            class: '',
            smclass: '', //smclass: 'font-small',
            groupid: [1,2,3,4,5,6,7,8],
            bgcolor: '#FF0000',
            color: '#ffffff',
            frame: 'logout',
            border: '#FF0000',
            perms: ['any']
          },
          sub: []
        }
      }

export default samerpproMenu
